import { useRead, usePut } from '@spotify-internal/creator-data-loading';

import { Logger } from '@mrkt/features/Platform';

import { useCurrentArtist } from '../../../../artists';
import { artistProfileLoader } from '../../../artistProfileLoader';
import { useDelete as useDeleteRequest } from '../../lib';

interface ConfirmationProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export function useDelete(onSuccess: () => void, onFailure: () => void) {
  const del = useDeleteRequest();

  const optimisticDelete = useOptimisticDelete();

  return async function deleteCurrentFundraisingPick() {
    const resp = await del();

    if (resp?.ok) {
      optimisticDelete();
      onSuccess();
    } else {
      logError(resp);
      onFailure();
    }
  };
}

// Optimistically delete fundraising pick client side if delete request was successful
function useOptimisticDelete() {
  const artist = useCurrentArtist();

  const artistProfile = useRead(artistProfileLoader, artist.id);
  const setArtistProfile = usePut(artistProfileLoader, artist.id);

  return function optimisticDelete() {
    if (artistProfile) {
      setArtistProfile({
        ...artistProfile,
        artistFundraisingPick: undefined,
      });
    }
  };
}

function logError(resp: Response | null) {
  // Log unexpected error code
  Logger.logError(
    'artist-fundraising-pick-delete-error',
    new Error(
      `Unexpected response${
        resp?.status ? ` status ${resp?.status}` : ` ${resp}`
      }`,
    ),
  );
}
